import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import styles from './BasicInput.scss';

export type BasicInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value'> & {
  isInvalid?: boolean;
  large?: boolean;
  value?: string | number | null;
  onChange: (value: string, name: string, event: React.ChangeEvent<HTMLInputElement>) => void;
  rightElement?: React.ReactNode;
};

export function BasicInput(props: BasicInputProps) {
  const { id, type = 'text', isInvalid, placeholder, value, large, onChange, rightElement, ...inputProps } = props;

  const { t } = useTranslation();

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value, e.target.name, e),
    [onChange]
  );

  return (
    <div className={styles.inputWrapper}>
      {rightElement && <div className={styles.rightElement}>{rightElement}</div>}
      <input
        id={id}
        type={type}
        className={classNames(styles.input, { [styles.error]: isInvalid, [styles.large]: large })}
        value={value || ''}
        placeholder={t(placeholder)}
        onChange={onChangeHandler}
        aria-invalid={isInvalid}
        {...inputProps}
      />
    </div>
  );
}

export default React.memo(BasicInput);
